import { render, staticRenderFns } from "./flavor.vue?vue&type=template&id=9f21a3ea&"
import script from "./flavor.vue?vue&type=script&lang=js&"
export * from "./flavor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\公司文件\\web\\uni-platform\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9f21a3ea')) {
      api.createRecord('9f21a3ea', component.options)
    } else {
      api.reload('9f21a3ea', component.options)
    }
    module.hot.accept("./flavor.vue?vue&type=template&id=9f21a3ea&", function () {
      api.rerender('9f21a3ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/router/views/production-manage/flavor/flavor.vue"
export default component.exports